/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchSubRuleFormConfiguration
 */
export interface SearchSubRuleFormConfiguration {
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof SearchSubRuleFormConfiguration
     */
    readonly fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {{ [key: string]: Array<CodeAndLabel>; }}
     * @memberof SearchSubRuleFormConfiguration
     */
    readonly fareSubTypes?: { [key: string]: Array<CodeAndLabel>; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleFormConfiguration
     */
    showFareTypes?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleFormConfiguration
     */
    showFareSubTypes?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleFormConfiguration
     */
    showAccountCode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleFormConfiguration
     */
    showExcludeUpsell?: boolean;
}

export function SearchSubRuleFormConfigurationFromJSON(json: any): SearchSubRuleFormConfiguration {
    return SearchSubRuleFormConfigurationFromJSONTyped(json, false);
}

export function SearchSubRuleFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSubRuleFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'fareSubTypes': !exists(json, 'fareSubTypes') ? undefined : json['fareSubTypes'],
        'showFareTypes': !exists(json, 'showFareTypes') ? undefined : json['showFareTypes'],
        'showFareSubTypes': !exists(json, 'showFareSubTypes') ? undefined : json['showFareSubTypes'],
        'showAccountCode': !exists(json, 'showAccountCode') ? undefined : json['showAccountCode'],
        'showExcludeUpsell': !exists(json, 'showExcludeUpsell') ? undefined : json['showExcludeUpsell'],
    };
}

export function SearchSubRuleFormConfigurationToJSON(value?: SearchSubRuleFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showFareTypes': value.showFareTypes,
        'showFareSubTypes': value.showFareSubTypes,
        'showAccountCode': value.showAccountCode,
        'showExcludeUpsell': value.showExcludeUpsell,
    };
}


